"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_CAREERSTAGES_HASH = void 0;
exports.GET_CAREERSTAGES_HASH = `
  {
    careerStages
  }
`;
//# sourceMappingURL=careerStages-queries.js.map